import { Host, ApiAuth } from './config'

import axios from 'axios'
import iView from 'view-design'
import { setToken, getToken } from './tools'
import router from '@/router'

export const baseUrl = (process.env.NODE_ENV === 'development' ? Host.dev : Host.pro)

class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
  }

  interceptors (instance) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      const { data, status } = res
			console.log(res,'响应拦截');
      if (data.code < 0) {
        if (data.code === -14) {
          setToken('')
          router.push({ name: 'login' })
        } else {
          iView.Message.error(data.msg)
        }
        throw new Error(data.msg)
      } else {
        return { data, status }
      }
    }, error => {
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = axios.create()
    let token = getToken()
    console.log(token)
    if (token === false || !token) {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {
          ApiAuth: ApiAuth
        }
      }, options)
    } else {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {
          ApiAuth: token
        }
      }, options)
    }
    this.interceptors(instance)
    return instance(options)
  }
}

const api_axios = new HttpRequest(baseUrl)
export default api_axios
